import React from 'react';

type CartSkeletonProps = {
  variant?: 'desktop' | 'mobile';
};

const CartSkeleton: React.FC<CartSkeletonProps> = ({ variant = 'desktop' }) => {
  const isDesktop = variant === 'desktop';

  return (
    <div
      role="status"
      aria-label="Loading cart"
      className={`w-full font-open-sans bg-[#F5F5F5] relative overflow-hidden ${
        isDesktop ? 'min-h-screen' : 'min-h-screen'
      }`}
    >
      <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none" />
      <div
        className={`mx-auto bg-white rounded-xl mt-10 relative ${
          isDesktop ? 'flex flex-row w-10/12 gap-8 p-6' : 'w-11/12 p-4 mt-24'
        }`}
      >
        <div className={isDesktop ? 'flex-1' : 'w-full'}>
          <div className="h-6 bg-gray-200/70 rounded w-40 mb-6 animate-pulse" />
          {Array.from({ length: isDesktop ? 2 : 3 }).map((_, index) => (
            <div
              key={index}
              className="border border-[#E9E9E9] rounded-lg p-4 mb-4 flex gap-4"
            >
              <div className="w-16 h-16 bg-gray-200/70 rounded-md animate-pulse flex-shrink-0" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-gray-200/70 rounded w-2/3 animate-pulse" />
                <div className="h-3 bg-gray-200/70 rounded w-1/3 animate-pulse" />
                <div className="h-8 bg-gray-200/70 rounded w-24 animate-pulse" />
              </div>
            </div>
          ))}
        </div>
        {isDesktop && (
          <div className="w-3/12">
            <div className="h-6 bg-gray-200/70 rounded w-32 mb-4 animate-pulse" />
            <div className="border border-[#E9E9E9] rounded-md p-4 h-[140px] space-y-4">
              <div className="h-5 bg-gray-200/70 rounded w-full animate-pulse" />
              <div className="h-12 bg-gray-200/70 rounded w-full animate-pulse" />
            </div>
          </div>
        )}
      </div>
      <span className="sr-only">Loading cart...</span>
    </div>
  );
};

export default CartSkeleton;
